module.exports = __webpack_public_path__ + "static/media/step-1.4fc552e9.png";